import { render } from "./App.vue?vue&type=template&id=5ad2d7eb"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5ad2d7eb&lang=css"

import exportComponent from "F:\\kobutsu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__